/* BOLODOO selected-menu navigation v2. Leaf links do not open a panel. */
(() => {
  const init = () => document.querySelectorAll('.bdnav').forEach(menu => {
    if (menu.dataset.bound) return;
    const root = menu.closest('.shopify-section-header');
    if (!root) return;
    menu.dataset.bound = 'true';
    const media = matchMedia('(min-width:1240px)');
    const entries = [...menu.querySelectorAll('.bdnav-nav-item')].map(item => {
      const toggle = item.querySelector('.bdnav-nav-toggle, .bdnav-nav-label-button');
      return {item, toggle, panel: toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null};
    });
    let active = null, timer, hovered = false;
    const sync = () => {
      if (!media.matches) return;
      const focused = root.contains(document.activeElement) && document.activeElement !== document.body;
      root.classList.toggle('bdnav-solid', menu.dataset.home !== 'true' || scrollY > 4 || !!active || hovered || focused);
    };
    const close = (restoreFocus = false) => {
      clearTimeout(timer);
      const previous = active;
      active = null;
      entries.forEach(({item, toggle, panel}) => {
        if (panel) panel.hidden = true;
        toggle?.setAttribute('aria-expanded', 'false');
        item.classList.remove('bdnav-active');
      });
      root.classList.remove('bdnav-open');
      if (restoreFocus) previous?.toggle?.focus();
      sync();
    };
    const open = entry => {
      if (!media.matches) return;
      close();
      if (!entry.panel) return;
      active = entry;
      entry.panel.hidden = false;
      entry.item.classList.add('bdnav-active');
      entry.toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('bdnav-open');
      sync();
    };
    entries.forEach(entry => {
      entry.item.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') open(entry); });
      entry.item.addEventListener('focusin', () => { if (active && active !== entry) close(); });
      entry.toggle?.addEventListener('click', () => active === entry ? close() : open(entry));
      entry.item.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && entry.panel) {
          event.preventDefault(); open(entry); entry.panel.querySelector('a,button')?.focus();
        }
      });
      entry.panel?.querySelector('.bdnav-close-menu')?.addEventListener('click', () => close(true));
    });
    root.addEventListener('pointerenter', () => { hovered = true; clearTimeout(timer); sync(); });
    root.addEventListener('pointerleave', () => { hovered = false; timer = setTimeout(() => close(), 150); });
    root.addEventListener('focusin', sync);
    root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); else sync(); }, 0));
    document.addEventListener('keydown', event => {
      if (root.isConnected && event.key === 'Escape' && active) { event.preventDefault(); close(true); }
    });
    ['pointerenter', 'focusin', 'click'].forEach(type => root.querySelector('.header__column')?.addEventListener(type, () => close()));
    document.addEventListener('pointerdown', event => { if (active && !root.contains(event.target)) close(); });
    const onScroll = () => { if (!root.isConnected) { window.removeEventListener('scroll', onScroll); return; } sync(); };
    window.addEventListener('scroll', onScroll, {passive:true});
    const resize = () => {
      close();
      root.classList.toggle('bdnav-ready', media.matches);
      root.classList.toggle('bdnav-home', media.matches && menu.dataset.home === 'true');
      if (!media.matches) root.classList.remove('bdnav-solid');
      sync();
    };
    media.addEventListener('change', resize);
    resize();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
